/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Event Safety Icon component.
 */
export const HomeDefaultView = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M4.22461 11.5439V21.0004C4.22461 21.2766 4.44847 21.5004 4.72461 21.5004H9.11582C9.39196 21.5004 9.61582 21.2766 9.61582 21.0004V15.9077C9.61582 15.6316 9.83968 15.4077 10.1158 15.4077H13.8904C14.1665 15.4077 14.3904 15.6316 14.3904 15.9077V21.0004C14.3904 21.2766 14.6143 21.5004 14.8904 21.5004H19.2816C19.5578 21.5004 19.7816 21.2766 19.7816 21.0004V11.5439' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M1 11.2211L6.50435 6.61053L11.6818 2.26936C11.8676 2.11355 12.1385 2.11355 12.3243 2.26936L17.5017 6.61053L23.0061 11.2211' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
    </svg>
  );
};

export default HomeDefaultView;
